import React, {Component} from 'react';
import {Link} from 'react-router';
import {RightArrow} from '~/shared/legacy_presentational-components/Elements/Elements';
import formStyles from '~/shared/legacy_presentational-components/Form/Form.module.scss';
import styles from '../Signup.module.scss';

class Awaiting extends Component {
    render() {
        return (
            <div className={styles.main_kyc}>
                <div>
                    <div className={styles.wrapper}>
                        <p className={styles.baseP}>
                            The KYC procedure is still in progress for you. We need to request some extra information
                            from you. Our officers will get in touch with you soon over e-mail.
                        </p>
                        <div className={styles.status_mail} />
                        <p className={styles.baseP}>
                            Please check your e-mail. Thanks for understanding and see you soon!
                        </p>
                    </div>
                    <Link className={formStyles.bottomButton} to='/assets'>
                        Back to my accounts <RightArrow />
                    </Link>
                </div>
            </div>
        );
    }
}

export default Awaiting;
